import React, { Component } from 'react';
import Modal from 'react-modal';
import './noInvitationDialog.scss';
import { isNoInvitationDialogOpen } from '../../../selectors';
import { connect } from 'react-redux';
import { toggleNoInvitationDialog } from '../../../actions/loanApplicationActions';


const customStyles = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    zIndex: '2000',
    padding: '1.2rem'
  },
  content: {
    maxWidth: 800,
    width: '70%',
    left: '-1%',
    top: '30%',
    bottom: 0,
    right: 0,
    position: 'relative',
    padding: '1.2rem',
    background: '#ffffff',
    overflow: 'hidden',
    backgroundClip: 'border-box',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,0.25)'
  },
  popUpContent: {
    background: "#000"
  }
};

export class NoInvitationDialog extends Component {

    state = {
      status: false
    };


    showModal = () => {
      return this.state.status === true;
    };

    componentWillReceiveProps(props) {
      this.setState({ status: props.isNoInvitationDialogOpen === true ? props.isNoInvitationDialogOpen : false });
    }

    render() {
      const { toggleNoInvitationDialog } = this.props;
      return (
        <Modal
          key="sessionTimeout"
          isOpen={this.showModal()}
          shouldCloseOnOverlayClick={false}
          style={customStyles}
          shouldCloseOnEsc={true}
        >
          <div className="no-invitation-dialog">
            <p className="no-invitation-dialog-text">To apply for a Barclays Personal Loan, please enter the invitation
                        code located on the offer letter you received in the mail.</p>
            <button onClick={toggleNoInvitationDialog} type="button" className="close" aria-label="Close"><i
              className="material-icons close-icon btn-close-error">clear</i></button>
          </div>
        </Modal>
      );
    }
}

const mapStateToProps = state => ({
  isNoInvitationDialogOpen: isNoInvitationDialogOpen(state)
});
const mapDispatchToProps = { toggleNoInvitationDialog };


export default connect(mapStateToProps, mapDispatchToProps)(NoInvitationDialog);
